"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BandcampIcon = void 0;

var _element = require("@wordpress/element");

var _primitives = require("@wordpress/primitives");

/**
 * WordPress dependencies
 */
const BandcampIcon = () => (0, _element.createElement)(_primitives.SVG, {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  version: "1.1"
}, (0, _element.createElement)(_primitives.Path, {
  d: "M15.27 17.289 3 17.289 8.73 6.711 21 6.711 15.27 17.289"
}));

exports.BandcampIcon = BandcampIcon;
//# sourceMappingURL=bandcamp.js.map